import {
  isShowAnalyticsEventLoaded,
  calculateCartData,
  caesarDecrypt,
  pushAnalyticsObjToDataLayer as addAnalyticsObjToDataLayer,
} from "@/utils/helper"
import { store } from "@/store"

const addShippingAnalytics = (status, message, i18n) => {
  if (window.adobeDataLayer) {
    const eventInfo = getShippingEventInfo("next", true)
    if (status) {
      eventInfo.eventStatus = status
    }
    if (message) {
      if (
        message === "failed to set shipping address." ||
        message === "failed to get shipping options."
      ) {
        message = i18n.shippingProcessError?.toLowerCase()
      }
      eventInfo.eventMsg = message
    }
    const { adobeDataLayer: { getState } = {} } = window
    const page = (getState && getState("page")) || {}
    window.adobeDataLayer.push({
      event: "cmp:click",
      eventInfo,
      page,
    })
  }
}

const getShippingEventInfo = (type, needJSON = false) => {
  const eventInfo = {
    eventAction: "checkout:shipping:" + type,
    eventName: "checkout:shipping:" + type,
    eventType: "navigation",
    eventMsg: "n/a",
    eventStatus: "n/a",
    internalLinkName: "continue to delivery",
    internalLinkPosition: "checkout",
    internalLinkType: "checkout:navigation",
    internalLinkZoneName: "checkout:shipping",
    internalLinkURL: "n/a",
    clickInternalLinks: "true",
  }
  if (needJSON) {
    return eventInfo
  }
  return JSON.stringify(eventInfo)
}

export const calculateCartAnalytics = ({ cart }) => {
  const page = window.pageObj || {}
  page.cart = cart
  page.user = getUserAnalyticsObject()
  // push this data to data layer in show event
  if (
    page.user &&
    (!page.user.gId || page.user.gId === "n/a") &&
    (!page.user.commerceToolsID || page.user.commerceToolsID === "n/a")
  ) {
    window.pageObj = page
    window.isShowAnalyticsEvent = true
  } else if (!isShowAnalyticsEventLoaded()) {
    window.adobeDataLayer.push({
      event: "cmp:show",
      page,
    })
    delete window.pageObj
  }
}

const getUserAnalyticsObject = (isFromRegisterUser = false) => {
  const hashedEmail = localStorage.getItem("hashedEmail")
  const customerProspect = localStorage.getItem("customerProspect")
  let isCustomerOrProspect = "n/a"
  if (hashedEmail && customerProspect) {
    try {
      const decryptedJSON = JSON.parse(
        caesarDecrypt(hashedEmail, customerProspect)
      )
      if (decryptedJSON.pastOrders.length) {
        isCustomerOrProspect = "customer"
      } else {
        isCustomerOrProspect = "prospect"
      }
    } catch (es) {
      // eslint-disable-next-line no-console
      console.log("decrypt error: ", es)
    }
  }
  // this user object should be updated when user log in or out.
  const user = {
    gId: "n/a",
    abTestName: "n/a",
    adBlocker: false,
    authStatus: "anonymous",
    commerceToolsID: "n/a",
    customerProspect: isCustomerOrProspect,
    envName: "development",
    knownStatus: "unknown",
    profileRole: "guest",
    returningStatus: "new visitor",
    emailId: hashedEmail || "n/a",
  }

  // fetch okta tokens for both logged in and anonymous users
  const oktaToken = localStorage.getItem("okta-token-storage")
  const anonymousOktaToken = localStorage.getItem("okta-anonymous-access-token")
  if (oktaToken && oktaToken !== "{}") {
    // user is logged in
    const oktaObject = JSON.parse(oktaToken)
    const claim = oktaObject?.accessToken?.claims || {}
    // user.uId = claim.uid || "n/a";
    if (claim.businessType === "Consumer") {
      user.profileRole = "consumer"
    } else {
      user.profileRole = "professional"
    }
    user.commerceToolsID = claim.commercetoolsID || "n/a"
    if (!isFromRegisterUser) {
      user.returningStatus = "returning customer"
    }
    user.authStatus = "logged in"
    user.knownStatus = "known"
  } else if (anonymousOktaToken) {
    // anonymous user
    let oktaObject
    try {
      oktaObject = JSON.parse(atob(anonymousOktaToken.split(".")[1])) || {}
    } catch (e) {
      // eslint-disable-next-line no-console
      console.warn("Anonymous Okta Token can not be decoded......")
    }
    if (oktaObject) {
      user.gId = oktaObject.gId || "n/a"
    }
  }
  return user
}

export const getEventInfo = step => {
  return JSON.stringify({
    eventAction: "checkout:" + step + ":edit",
    eventName: "checkout:" + step + ":edit",
    eventType: "navigation",
    eventMsg: "n/a",
    eventStatus: "n/a",
    internalLinkName: "edit",
    internalLinkPosition: "checkout",
    internalLinkType: "checkout:navigation",
    internalLinkZoneName: "checkout:" + step,
    internalLinkURL: "n/a",
    clickInternalLinks: "true",
  })
}

export const getAddPromoEventInfo = async (promoCodeLable = "expand") => {
  if (window.adobeDataLayer) {
    const eventInfo = {
      eventName: "checkout:payment & billing:promo code:expand",
      eventAction: "checkout:payment & billing:promo code:expand",
      eventType: "navigation",
      eventMsg: "n/a",
      eventStatus: "n/a",
      internalLinkName: promoCodeLable,
      internalLinkPosition: "checkout",
      internalLinkZoneName: "checkout:payment and billing",
      internalLinkType: "checkout:promo code",
      internalLinkURL: "n/a",
      clickInternalLinks: "true",
    }
    addAnalyticsObjToDataLayer(eventInfo, "cmp:click")
  }
}

export const updatePromoAnalytics = async (
  status,
  cartObj,
  promo,
  action,
  productDiscounts
) => {
  const { adobeDataLayer: { getState } = {} } = window
  const page = (getState && getState("page")) || {}
  const eventInfo = {
    eventAction: "checkout:payment & billing:promo code:" + action,
    eventName: "checkout:payment & billing:promo code:" + action,
    eventType: "navigation",
    eventMsg:
      status === "success"
        ? action === "remove"
          ? "promocode removed successfully"
          : "promocode applied successfully"
        : status?.toLowerCase(),
    eventStatus: status === "success" ? "success" : "failure",
    internalLinkName: action,
    internalLinkPosition: "checkout",
    internalLinkType: "checkout:promo code",
    internalLinkZoneName: "checkout:payment & billing",
    internalLinkURL: "n/a",
    clickInternalLinks: "true",
    promoCode: promo,
  }

  if (cartObj) {
    const { cart } = await calculateCartData(
      {
        cart: cartObj,
        i18n: {
          productDiscounts: productDiscounts || "Product Discounts",
        },
      },
      true
    )
    page.cart = cart
  }

  window.adobeDataLayer.push({
    event: "cmp:click",
    eventInfo,
    page,
  })
}

export const getCheckoutReviewEventInfo = (
  type,
  link,
  needJson,
  isModalOpen = false,
  status = "n/a"
) => {
  const extraText = isModalOpen ? "something went wrong:" : ""
  const extraText2 = isModalOpen ? ":modal:something went wrong" : ""
  const eventInfo = {
    eventAction: `checkout:review:${extraText}${type}`,
    eventName: `checkout:review:${extraText}${type}`,
    eventType: "navigation",
    eventMsg: "n/a",
    eventStatus: status || "n/a",
    internalLinkName: type,
    internalLinkPosition: `checkout${extraText2}`,
    internalLinkType: "checkout:navigation",
    internalLinkZoneName: `checkout:review${extraText2}`,
    internalLinkURL: link
      ? (link.indexOf("http") === -1 ? window.location.origin : "") + link
      : "n/a",
    clickInternalLinks: "true",
  }
  if (needJson) {
    return eventInfo
  }
  return JSON.stringify(eventInfo)
}

export const addPlaceOrderDataLayer = async (
  link,
  isModalOpen = false,
  paymentMethod = "n/a",
  status = "n/a"
) => {
  const eventInfo = getCheckoutReviewEventInfo(
    "place order",
    link,
    true,
    isModalOpen,
    status
  )
  const { adobeDataLayer: { getState } = {} } = window

  let pageData = (getState && getState("page")) || {}
  const cartObj = store?.getState()?.cart?.cart
  if (cartObj) {
    try {
      const { cart } = await calculateCartData({ cart: cartObj }, true)
      pageData = { ...pageData, cart }
    } catch (error) {
      console.error("Error calculating cart data:", error)
    }
  }
  const page = {
    ...pageData,
    cart: {
      ...pageData.cart,
      payment: { paymentMethod: paymentMethod.toLowerCase() },
    },
  }

  window.adobeDataLayer.push({
    event: "cmp:click",
    eventInfo,
    page,
  })
}

export const getCheckoutSignEventInfo = type => {
  const eventInfo = {
    eventAction: "checkout:shipping:sign in",
    eventName: "checkout:shipping:sign in",
    eventType: "navigation",
    eventMsg: type === "success" ? "n/a" : "please enter a valid password",
    eventStatus: type === "success" ? "success" : "failure",
    internalLinkName: "sign in",
    internalLinkPosition: "checkout",
    internalLinkType: "checkout:navigation",
    internalLinkZoneName: "checkout:shipping",
    internalLinkURL: "n/a",
    clickInternalLinks: "true",
  }

  return eventInfo
}
export const addCheckoutSignDataLayer = type => {
  const eventInfo = getCheckoutSignEventInfo(type)
  const { adobeDataLayer: { getState } = {} } = window
  const page = (getState && getState("page")) || {}
  window.adobeDataLayer.push({
    event: "cmp:click",
    eventInfo,
    page,
  })
}

export const addAnalyticsAddressEdit = () => {
  const eventInfo = {
    clickInternalLinks: "true",
    eventAction: "checkout:shipping:edit",
    eventMsg: "n/a",
    eventStatus: "n/a",
    eventName: "checkout:shipping:edit",
    eventType: "navigation",
    internalLinkName: "edit",
    internalLinkPosition: "checkout",
    internalLinkType: "checkout:navigation",
    internalLinkURL: "n/a",
    internalLinkZoneName: "checkout:shipping",
  }
  addAnalyticsObjToDataLayer(eventInfo, "cmp:click")
}

export const addAnalyticsVerifyAddress = (action = "") => {
  const eventInfo = {
    eventAction: `checkout:shipping verify address:${action}`,
    eventName: `checkout:shipping verify address:${action}`,
    eventType: "navigation",
    eventMsg: "n/a",
    eventStatus: action === "use original" ? "success" : "n/a",
    internalLinkName: action,
    internalLinkPosition: "checkout",
    internalLinkType: "checkout:navigation",
    internalLinkZoneName: "checkout:shipping verify address",
    internalLinkURL: "n/a",
    clickInternalLinks: "true",
  }
  pushAnalyticsObjToDataLayer(eventInfo)
}

export const addAnalyticsRemoveItems = (product = {}) => {
  const productArrayLists = product ? product.length > 1 : false
  const prodcutLists = []
  if (product?.length) {
    product.forEach(prod => {
      const productInformation = JSON.parse(prod?.customProductInfo)
      prodcutLists.push(productInformation?.productInfo)
    })
  }
  const removeText = productArrayLists ? "remove items" : "remove item"
  const eventInfo = {
    clickInternalLinks: "true",
    eventAction: `checkout:continue to delivery:we are sorry we cannot ship to your location:${removeText}`,
    eventMsg: "n/a",
    eventStatus: "n/a",
    eventName: `checkout:continue to delivery:we are sorry we cannot ship to your location:${removeText}`,
    eventType: "navigation",
    internalLinkName: removeText,
    internalLinkPosition: "checkout",
    internalLinkType: "checkout:navigation",
    internalLinkURL: "n/a",
    internalLinkZoneName:
      "checkout:we are sorry we cannot ship to your location",
  }

  const productInfoJSON =
    prodcutLists?.length > 0 ? { productInfo: prodcutLists } : null
  pushAnalyticsObjToDataLayer(eventInfo, productInfoJSON)
}

const pushAnalyticsObjToDataLayer = (eventInfo = {}, productInfoJSON = {}) => {
  const { adobeDataLayer: { getState } = {} } = window
  const page = (getState && getState("page")) || {}
  const event = "cmp:click"
  let DLObj = {
    event,
    eventInfo,
    page,
  }
  if (productInfoJSON?.productInfo) {
    DLObj = { ...DLObj, productInfo: productInfoJSON.productInfo }
  }
  window.adobeDataLayer.push(DLObj)
}
export { addShippingAnalytics }
